import { getPrices } from '@/api/apiMain';
import { CurrencyRates } from '@/api/getExchangeRates';
import { useQuery } from '@tanstack/vue-query';

async function getRates(): Promise<CurrencyRates> {
  const rates: CurrencyRates = {};
  const data = await getPrices();
  data.forEach((item: any) => {
    rates[item.name] = item.rateToUsd;
  });
  return rates;
}

export default function useExchangeRates() {
  return useQuery({
    queryKey: ['exchangeRates-v2'],
    queryFn: getRates,
    staleTime: 1000 * 60 * 10,
  });
}
